import { useCallback } from 'react';
import { useCampaignEditorContext } from 'sections/onsite-campaigns/pages/CampaignEditor/contexts/CampaignEditorContext';
import { ExitIntentAreas } from 'sections/onsite-campaigns/types';

export const useSetExitIntent = () => {
  const { dispatch } = useCampaignEditorContext();
  return useCallback(
    (exitIntents: ExitIntentAreas[]) =>
      dispatch({ type: 'SET_CAMPAIGN_EXIT_INTENT', payload: { exitIntentAreas: exitIntents } }),
    [dispatch],
  );
};
